import AutoP from './AutoP';

export default AutoP;
